import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=1e3cdd64&scoped=true"
import script from "./resume.vue?vue&type=script&lang=js"
export * from "./resume.vue?vue&type=script&lang=js"
import style0 from "./resume.vue?vue&type=style&index=0&id=1e3cdd64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cdd64",
  null
  
)

export default component.exports